export default __webpack_public_path__ + "d19e3ddd382acb9f8b161e6cd1e9c09f.png";